<template>
  <section class="about-container section-padding-top ">
    
    <div class="about-content">
        <p>This resource describes a set of activities that can be used in either an online or a face-to-face teaching context. They include a short description of the activity and some notes to help you start to think about how to use them in a classroom.</p>
        <p>You will certainly think of many more ideas, and better ones, as you plan; the resource is intended to provide a stimulus for developing ideas about teaching sessions.</p>
        <div id="two"></div> 
        <p>The activities are based on seminar-type activities and would be tutor-facilitated. Ideas for managing facilitation either online or on-campus, for individual, small group, or large group, are included here. They could be carried out in timetabled sessions, or as independent study.</p>
    </div>
    <div class="custom-shape-divider-bottom-1663978418">
      <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" class="shape-fill"></path>
      </svg>
      </div>
  </section>

</template>

<script>
export default {

}
</script>

<style scoped>

.custom-shape-divider-bottom-1663978418 {
    position: absolute;
    bottom: 50;
    left: 0;
    width: 100%;
    overflow: hidden;
    line-height: 0;
    /* transform: rotate(180deg); */
}

.custom-shape-divider-bottom-1663978418 svg {
    position: relative;
    display: block;
    width: calc(100% + 1.3px);
    height: 136px;
}

.custom-shape-divider-bottom-1663978418 .shape-fill {
    fill: #F6F6F6;
}
</style>